import type { TransactionSegment } from '@pages/Expenses/TransactionsPage/transactions.types.ts';

export const SEGMENTS = [
  { value: 'all', label: 'All' },
  { value: 'payments', label: 'Payments' },
  { value: 'refunds', label: 'Refunds' },
] as const;

export const APPROVALS_SEGMENT = { value: 'approvals', label: 'Approvals' } as const;

export const SEGMENT_EMPTY_STATE: Record<
  TransactionSegment,
  { title: string; desc?: string; canAdd: boolean }
> = {
  all: { title: 'Please add a transaction to get started.', canAdd: true },
  payments: { title: 'Please add a payment to get started.', canAdd: true },
  refunds: { title: 'No refunds match. Please try widening your filters.', canAdd: false },
  approvals: {
    title: 'Nothing to approve',
    desc: 'Payments sent for your approval will show up here.',
    canAdd: false,
  },
};

export const DATE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: '30', label: 'Last 30 Days' },
  { value: '90', label: 'Last 90 Days' },
  { value: 'year', label: 'This Year' },
];

export const AMOUNT_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'under-1000', label: 'Under $1,000' },
  { value: '1000-5000', label: '$1,000 – $5,000' },
  { value: 'over-5000', label: 'Over $5,000' },
];

export const DEFAULT_FILTERS = { date: 'all', category: 'all', amount: 'all' };

// ponytail: parses formatDate's "Jul 18, 2026" back; reading row.createdAt instead would drop the round trip
export const rowDate = (value: string): Date | null => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const matchesDate = (value: string, filter: string) => {
  if (filter === 'all') return true;
  const date = rowDate(value);
  if (!date) return false;
  const now = new Date();
  if (filter === 'year') return date.getFullYear() === now.getFullYear();
  return now.getTime() - date.getTime() <= Number(filter) * 24 * 60 * 60 * 1000;
};
